import { Tabs } from '@/components';
import { TenantManagerResourceGuard } from '@/features/authentication/_components/TenantManagerResourceGuard';
import type { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

type TabKey = 'users' | 'organizations' | 'roles' | 'snapshots';

type Props = {
  type: TabKey;
  tabBarExtraContent?: ReactNode;
};

const BASE_ROUTE = '/tenant-manager';

export const HeaderTab: FC<Props> = ({ type, tabBarExtraContent }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Tabs
      activeKey={type}
      items={[
        {
          key: 'users' satisfies TabKey,
          label: t('users-page'),
        },
        {
          key: 'organizations' satisfies TabKey,
          label: t('organizations-page'),
        },
        {
          key: 'roles' satisfies TabKey,
          label: t('roles-page'),
        },
        {
          key: 'snapshots' satisfies TabKey,
          label: t('snapshots-name'),
        },
      ]}
      onChange={(activeKey) => {
        const route =
          (activeKey as TabKey) === 'users'
            ? `${BASE_ROUTE}`
            : `${BASE_ROUTE}/${activeKey}`;
        navigate(route, { replace: true });
      }}
      tabBarExtraContent={
        tabBarExtraContent ? (
          <TenantManagerResourceGuard>
            {tabBarExtraContent}
          </TenantManagerResourceGuard>
        ) : undefined
      }
    />
  );
};
